import React from 'react'
import PropTypes from 'prop-types'
import CountryPageLatestNewsOnMarketAccessBlockItem from './CountryPageLatestNewsOnMarketAccessBlockItem'
import NoContent from 'components/NoContent'
import './CountryPageLatestNewsOnMarketAccessBlock.scss'
import Link from 'components/Link'

const CountryPageLatestNewsOnMarketAccessBlock = ({ heading, news, lang, newsArchiveLink}) => {
    return (
        news && news.length > 0 ? (
            <div className="country-page-latest-news-on-market-access-block">
                {heading && <h2 className="country-page-latest-news-on-market-access-block__heading">{heading}</h2>}
                <ul className="country-page-latest-news-on-market-access-block__list">
                    {news.map((item, index) => (
                        <li key={index} className="country-page-latest-news-on-market-access-block__list-item">
                            <CountryPageLatestNewsOnMarketAccessBlockItem 
                                {...item} 
                                pablishedLabel={lang.publishedLabel}
                                headingTagLevel={heading ? 3 : 2}
                            />
                        </li>
                    ))}    
                </ul>
                {newsArchiveLink && (
                    <div className="country-page-latest-news-on-market-access-block__archive-link-holder">
                        <Link
                            {...newsArchiveLink} 
                        />
                    </div>
                )}
            </div>
        ) : (
            <NoContent 
                heading={heading}
                message={lang.noContentMessage}
                link={newsArchiveLink} 
            />
        )
    )
}

CountryPageLatestNewsOnMarketAccessBlock.propTypes = {
    heading: PropTypes.string,
    news: PropTypes.arrayOf(PropTypes.exact(CountryPageLatestNewsOnMarketAccessBlockItem.propTypes)).isRequired,
    lang: PropTypes.shape({
        publishedLabel: PropTypes.string.isRequired,
        noContentMessage: PropTypes.string.isRequired
    }).isRequired,
    newsArchiveLink: PropTypes.exact(Link.propTypes),
}

export default CountryPageLatestNewsOnMarketAccessBlock
